import PageHeader from '@components/PageHeader';
import { useI18n } from '@/i18n';
import { IconShield } from '@components/icons';

export default function Privacy() {
  const { t } = useI18n();
  const rights = t('privacy.rights');

  return (
    <>
      <PageHeader title={t('privacy.title')} subtitle={t('privacy.subtitle')} />
      <div className="px-5 md:px-0 pb-6 space-y-4">
        <div className="greeting-band !py-6">
          <div className="flex items-center gap-3">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-white/15"><IconShield size={22} /></span>
            <p className="text-sm text-white/85 leading-snug">{t('privacy.banner')}</p>
          </div>
        </div>

        <div className="card divide-y divide-gray-100">
          {(Array.isArray(rights) ? rights : []).map(([title, desc]) => (
            <div key={title} className="px-5 py-4">
              <p className="font-semibold text-glk-dark">{title}</p>
              <p className="text-sm text-gray-500 mt-0.5">{desc}</p>
            </div>
          ))}
        </div>

        <div className="card p-5 text-center">
          <p className="text-sm text-gray-500">{t('privacy.soon')}</p>
          <p className="text-xs text-gray-400 mt-1">{t('privacy.soonNote')}</p>
        </div>
      </div>
    </>
  );
}
